import { AlertDismissible } from 'app/modules/reports/components'
import React from 'react'

export function Banner() {
  const content = (
    <div>
      Due to scheduled maintenance, Filescan.io will be unavailable during this time period:{' '}
      <strong>10:00-18:00 UTC, Thursday, February 20, 2025</strong>
    </div>
  )

  return <AlertDismissible title="Filescan.io Maintenance" content={content} type="info" />

  // Old banner content, kept to preserve styles
  return (
    <div className="container-fluid header-news mb-4">
      <div>
        <span className="mobile-block">Filescan.IO acquired by OPSWAT</span>
        <span className="mobile-hide">|</span>October 27, 2022<span>|</span>
        <a
          href="https://opswat.com/blog/opswat-announces-filescanio-asset-acquisition"
          target="_blank"
          rel="noreferrer"
        >
          View Press Release
        </a>
      </div>
      <div className="mt-3">
        OPSWAT is firmly committed to manage and continue the successful growth story of the
        <br /> Filescan.IO community and is working to ensure a smooth transition.
      </div>
    </div>
  )
}
